import { NgModule } from '@angular/core';

import { NpFlexGridMenuComponent } from '@newpla/wijmo';

// import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

// import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
// import { WjGridSearchModule } from '@grapecity/wijmo.angular2.grid.search';

// import * as wjcGridFilter from '@grapecity/wijmo.grid.filter';
// import * as wjcGrid from '@grapecity/wijmo.grid';

// export * from './lib/newpla-wijmo.module';
export * from '@grapecity/wijmo.grid.filter';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { WjGridSearchModule } from '@grapecity/wijmo.angular2.grid.search';

import { NpFlexGridSelector2Component } from '../../../../newpla-modules-ng17/newpla-wijmo/src/lib/flex-gird/np-flex-grid-selector2/np-flex-grid-selector2.component';
import { WjGridGrouppanelModule } from '@grapecity/wijmo.angular2.grid.grouppanel';

const modules = [
  WjGridModule, WjGridFilterModule, WjGridSearchModule, WjGridGrouppanelModule,
  //
  NpFlexGridMenuComponent, NpFlexGridSelector2Component
];

@NgModule({
  declarations: [
  ],
  imports: [modules],
  exports: [modules]
})
export class NpxWijmoGridModule { }
